import {
    ApiClientFactory
} from '../ApiClientFactory';
import {
    API_URL
} from '../Variables';

let clientFactory = new ApiClientFactory();

export const LastLessonClient = {
    /**
     *
     * Returns group
     */
    getLastLesson() {
        return clientFactory.get(API_URL + 'user/tracking');
    }

};